import Swiper, { Navigation, Pagination, Lazy, EffectFade, Autoplay } from 'swiper';

export default (function () {

  let DOM = {};

  Swiper.use([Navigation, Pagination, Lazy, EffectFade, Autoplay]);

  function cacheDom() {
    DOM.items = document.querySelectorAll('[data-module="swiper"]');
  }

  function bindUIActions() {

    Array.from(DOM.items).map(function(item) {

      let container = item.querySelector('.swiper-container');
      let nextEl = item.querySelector('.swiper-button-next');
      let prevEl = item.querySelector('.swiper-button-prev');
      let pagination = item.querySelector('.swiper-pagination');

      // Get options from attributes
      let effect = item.dataset.effect;
      let breakpoints = item.dataset.breakpoints;

      let options = {
        slidesPerView: 1,
        loop: true,
        speed: 1000,
        autoplay: {
          delay: 5000,
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
      };

      // Breakpoints
      if (breakpoints) {
        options.breakpoints = JSON.parse(breakpoints);
      }

      // Effect
      if (effect) {
        options.effect = 'fade';
        options.fadeEffect = {
          crossFade: true
        };
      }

      // Pagination
      if (pagination) {
        options.pagination = {
          el: pagination,
          clickable: true,
        };
      }

      // Init
      let swiper = new Swiper(container, options);
    });
  }

  function init() {
    cacheDom();

    if (DOM.items && DOM.items.length > 0) {
      bindUIActions();
    }
  }

  return {
    init: init,
  }
})();

